<template>
  <div>
    <h4 class="m-3">
      SEAGULL INSTRUCTIONS
    </h4>
    <div class="row mx-3">
      <ul>
        <li>
          <h5>
            Click on this link : <a
              href="https://www.seagull.no/"
              target="_blank"
            >https://www.seagull.no</a>
          </h5>
        </li>
        <li>
          <h5>Click STA LOGIN</h5>
          <div class="row">
            <div class="col-8">
              <img
                class="img-fluid"
                src="../../../assets/seagull_instruction.jpg"
                alt="STA LOGIN"
              >
            </div>
          </div>
        </li>
        <li>
          <h5>How to log in:  </h5>
          <h5>Company: k line ship management</h5>
          <h5>Seagull Id:  your crew ipn</h5>
          <h5>Password: mm.dd.yyyy (bdate)</h5>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SeagullInstructions"
}
</script>

<style scoped>

</style>